import { ref, onMounted } from 'vue';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  name: 'MgDepSelect',
  setup(props, {
    emit
  }) {
    const depCateList = ref([]);
    const {
      runAsync: getDepCateList,
      loading,
      error
    } = fetchApi('kpi.depCate.getList');
    const fetchData = async () => {
      const {
        error,
        rows = []
      } = await getDepCateList({
        count: -1
      });
      if (error) return;
      depCateList.value = rows;
    };
    onMounted(() => {
      fetchData();
    });
    return {
      depCateList,
      loading,
      error
    };
  }
};